var _class, _temp2;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import get from 'lodash/get';
import ReactPlaceholder from 'react-placeholder';
var DIRECTION = {
  ASC: 'asc',
  DESC: 'desc'
};
var SortableTable = (_temp2 = _class = function (_Component) {
  _inherits(SortableTable, _Component);

  function SortableTable() {
    var _temp, _this, _ret;

    _classCallCheck(this, SortableTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      sortColumnId: get(_this.props.columns.find(function (c) {
        return c.isInitialSort;
      }), 'id') || '' + _this.props.columns[0].id,
      sortDirection: DIRECTION.DESC
    }, _this.changeSort = function (e) {
      var ASC = DIRECTION.ASC,
          DESC = DIRECTION.DESC;
      var _this$state = _this.state,
          sortColumnId = _this$state.sortColumnId,
          sortDirection = _this$state.sortDirection;
      var columnId = e.currentTarget.id;

      var column = _this.props.columns.find(function (c) {
        return c.id === columnId;
      });

      var reverseDirection = column ? column.reverseSortDirection : null;
      var direction = sortColumnId === columnId ? sortDirection === ASC ? DESC : ASC : reverseDirection ? ASC : DESC;

      _this.setState({
        sortColumnId: columnId,
        sortDirection: direction
      });

      if (_this.props.onSortingChange) {
        _this.props.onSortingChange(columnId, direction);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SortableTable.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        columns = _props.columns,
        render = _props.render,
        ready = _props.ready,
        placeholderRows = _props.placeholderRows;
    var _state = this.state,
        sortColumnId = _state.sortColumnId,
        sortDirection = _state.sortDirection;
    return React.createElement('table', {
      className: 'dd-table dd-table-hover'
    }, React.createElement('thead', null, React.createElement('tr', null, columns.map(function (_ref) {
      var id = _ref.id,
          label = _ref.label,
          isSortable = _ref.isSortable,
          reverseSortDirection = _ref.reverseSortDirection;
      return React.createElement('th', {
        key: id,
        id: id,
        onClick: isSortable && _this2.changeSort,
        className: isSortable ? 'sortable' : null
      }, React.createElement('span', null, label), isSortable && React.createElement('span', {
        className: 'carret'
      }, React.createElement(FontAwesomeIcon, {
        icon: sortColumnId === id ? sortDirection === DIRECTION.ASC ? reverseSortDirection ? 'chevron-down' : 'chevron-up' : reverseSortDirection ? 'chevron-up' : 'chevron-down' : 'chevron-down',
        color: sortColumnId === id ? '#2882de' : null
      })));
    }))), React.createElement('tbody', null, ready ? render(this.state) : Array.from({
      length: placeholderRows || 3
    }, function (v, k) {
      return k;
    }).map(function (x) {
      return React.createElement('tr', {
        key: x
      }, columns.map(function (_ref2) {
        var id = _ref2.id;
        return React.createElement('td', {
          key: id
        }, React.createElement(ReactPlaceholder, {
          type: 'textRow',
          ready: false
        }, ''));
      }));
    })));
  };

  return SortableTable;
}(Component), _class.defaultProps = {
  ready: true
}, _temp2);
export { SortableTable as default };